import lodash from 'lodash';

class RemapperUtil {
  remap(data, definitions) {
    if (!Array.isArray(data)) {
      return [];
    }

    const result = [];
    let temp = {};

    const originalKeys = [];
    for (const key in definitions) {
      const item = definitions[key];
      const original = Object.keys(item)[0];
      originalKeys.push(original);
    }

    for (const dataItem of data) {
      temp = {};
      for (const key in definitions) {
        const item = definitions[key];
        const original = Object.keys(item)[0];
        const renamed = item[original];
        temp[renamed] = dataItem[original];
      }

      for (const dataItemKey in dataItem) {
        const item = dataItem[dataItemKey];
        if (originalKeys.indexOf(dataItemKey) <= -1) {
          temp[dataItemKey] = item;
        }
      }
      result.push(temp);
    }
    return result;
  }

  remapAsClone(data, definitions) {
    const dataCloned = lodash.cloneDeep(data);
    return this.remap(dataCloned, definitions);
  }
}

export default new RemapperUtil();
